// NOTICE: KAPTION-INTEGRATION
// whatsapp-calling — the Warm Paper class strings the call surfaces share
// (feature: warm-paper-redesign; _design-reference/warm-paper-contract.md).
// Cards and rows come from components-next/warm-paper (WarmCard, WarmListRow,
// WarmPageHeader); these are the few pieces those primitives do not cover, so
// the toast, dock, bubble and detail pane spell them one way.

// A surface that floats over the app (dock, picker): the card, plus the one
// minimal overlay shadow — never a hand-rolled `shadow-lg`.
export const PAPER_OVERLAY =
  'rounded-xl border border-n-weak bg-n-solid-1 shadow-[0_4px_12px_rgb(0_0_0/0.06),0_16px_32px_-16px_rgb(0_0_0/0.22)]';

// Contract "Alerts / banners / callouts": toasts are the near-black attention
// card. Light: ink card, light text. Dark: a bar just darker than the ground
// with a hairline. Rounded, no shadow beyond the overlay one.
export const PAPER_TOAST =
  'rounded-xl border border-transparent bg-[#16181b] text-[#f2f2f3] shadow-[0_4px_12px_rgb(0_0_0/0.06),0_16px_32px_-16px_rgb(0_0_0/0.3)] dark:border-n-weak dark:bg-[#0c0c0d]';

// `.label-eyebrow` without depending on the `.warm-paper` body class.
export const PAPER_EYEBROW =
  'text-[11px] font-medium uppercase leading-none tracking-[0.08em] text-n-slate-10';

// Icon tile: linen (alpha veil) tile, deep-hue glyph — never a saturated tile
// with a white glyph.
export const PAPER_ICON_TILE =
  'flex shrink-0 items-center justify-center rounded-md bg-n-alpha-2';

// Neutral chip (spec CHIP neutral).
export const PAPER_CHIP =
  'inline-flex items-center gap-1 rounded border border-n-weak bg-n-alpha-1 px-1.5 py-0.5 text-[11px] font-medium leading-none text-n-slate-11';

// Status chip shape; the tint comes from kaptionCallModel.statusChip.
export const PAPER_STATUS_CHIP =
  'inline-flex items-center rounded px-1.5 py-0.5 text-[11px] font-medium leading-none';

// Inputs sit on a recessed well.
export const PAPER_INPUT =
  '!mb-0 h-9 rounded-md border border-n-weak bg-n-alpha-black2 !py-0 px-2.5 text-sm text-n-slate-12';

// Kaption style guide — Transcripts / Suggestions are orange (#F97316) with
// the audio-lines glyph (style.kaption.us/STYLE.md).
export const TRANSCRIPT_ACCENT = 'text-[#F97316]';
export const TRANSCRIPT_TINT = 'bg-[#F97316]/10';
export const TRANSCRIPT_ICON = 'i-lucide-audio-lines';

// whatsapp-calling-ai.UI.2..5 — Kaption style guide: AI (Copilot / assistant)
// is violet (#7C3AED) with the sparkles glyph.
export const AI_ACCENT = 'text-[#7C3AED] dark:text-[#A78BFA]';
export const AI_TINT = 'bg-[#7C3AED]/10';
export const AI_ICON = 'i-lucide-sparkles';
export const AI_CHIP =
  'inline-flex items-center gap-1 rounded bg-[#7C3AED]/10 px-1.5 py-0.5 text-[11px] font-medium leading-none text-[#7C3AED] dark:text-[#A78BFA]';
